module.exports = __webpack_public_path__ + "static/media/plasticLaundryBag.611cb567.svg";